import request from '@/utils/request'

export function getWriterContact(params) {
  return request({
    url: '/writer/getwritercontact',
    method: 'get',
    params:params
  })
}

export function updataWriterComment(data) {
  return request({
    url: '/writer/updatarecruitercomment',
    method: 'post',
    data:data
  })
}

export function getWriterRank(data) {
  return request({
    url: '/writer/getwriterrank',
    method: 'get',
    params:data
  })
}

export function upDataWriterInfo(data) {
  return request({
    url: '/writer/updatawriterinfo',
    method: 'post',
    data:data
  })
}

export function getWriterInfo(params) {
  return request({
    url: '/writer/getwriterinfo',
    method: 'get',
    params:params
  })
}

export function getWriterCV(wid) {
  return request({
    url: '/writer/getwritercv',
    method: 'get',
    // responseType: 'blob',
    params:{
      writer_id:wid,
    }
  })
}

export function getWritersList(data) {
  return request({
    url: '/writer/getwriterlist',
    method: 'get',
    params: data
  })
}

export function newWriter(data) {
  return request({
    url: '/writer/newwriter',
    method: 'post',
    data:data
  })
}
